"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const Sidebar_1 = require("../Sidebar");
const utilities_1 = require("../utilities");
const utilities_2 = require("../Themes/utilities");
const polished_1 = require("polished");
const HeaderBar_1 = tslib_1.__importDefault(require("../HeaderBar"));
const Icon_1 = tslib_1.__importDefault(require("../Icon"));
const LayoutContext_1 = require("./LayoutContext");
const ModalContextProvider_1 = tslib_1.__importDefault(require("./ModalContextProvider"));
const Navigation_1 = tslib_1.__importDefault(require("./Navigation"));
const react_1 = tslib_1.__importDefault(require("react"));
const roles_connector_1 = tslib_1.__importDefault(require("@sportnet/roles-connector"));
const ScrollLayout_1 = tslib_1.__importDefault(require("../Layouts/ScrollLayout"));
const StatusBar_1 = tslib_1.__importDefault(require("./StatusBar"));
const StatusBarAction_1 = tslib_1.__importDefault(require("./StatusBarItems/StatusBarAction"));
const StatusBarAppSpaceSwitch_1 = tslib_1.__importDefault(require("./StatusBarItems/StatusBarAppSpaceSwitch"));
const StatusBarAppSwitch_1 = tslib_1.__importDefault(require("./StatusBarItems/StatusBarAppSwitch"));
const StatusBarCloseButton_1 = tslib_1.__importDefault(require("./StatusBarItems/StatusBarCloseButton"));
const StatusBarNotifications_1 = tslib_1.__importDefault(require("./StatusBarItems/StatusBarNotifications"));
const StatusBarUser_1 = tslib_1.__importDefault(require("./StatusBarItems/StatusBarUser"));
const js_cookie_1 = tslib_1.__importDefault(require("js-cookie"));
const styled_components_1 = tslib_1.__importStar(require("../Themes/styled-components"));
const NAVIGATION_OPENED_COOKIES_KEY = 'navigation_opened';
const Wrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  overflow: hidden;
`;
const InnerWrapper = styled_components_1.default.div `
  position: relative;
  overflow: hidden;
  display: flex;
  flex: 1 0 0;
  height: 100%;
`;
const Body = styled_components_1.default.div `
  position: relative;
  overflow: hidden;
  display: flex;
  flex: 1 0 0;
  height: 100%;
  background-color: #f4f5f9;
`;
const Pushable = styled_components_1.default.div `
  display: flex;
  flex: 1 0 0;
  min-width: 0;
  transition: margin-right ${Sidebar_1.SIDEBAR_TRANSITION},
    margin-left ${Sidebar_1.SIDEBAR_TRANSITION};
  max-width: 100%;
  height: 100%;
  ${({ $isPushingFromRight }) => $isPushingFromRight &&
    (0, styled_components_1.css) `
      ${(0, utilities_2.mb)(Sidebar_1.SIDEBAR_PUSH_THRESHOLD_MEDIA_QUERY)} {
        margin-right: ${(0, polished_1.rem)(Sidebar_1.SIDEBAR_WIDTH)};
      }
    `}
  ${({ $isPushingFromLeft }) => $isPushingFromLeft &&
    (0, styled_components_1.css) `
      ${(0, utilities_2.mb)(Sidebar_1.SIDEBAR_PUSH_THRESHOLD_MEDIA_QUERY)} {
        margin-left: ${(0, polished_1.rem)(Sidebar_1.SIDEBAR_WIDTH)};
      }
    `}
`;
class TheLayout extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.closeNavigation = () => {
            this.setState({ navigationOpened: false });
        };
        this.closeNavigationMobile = () => {
            const element = document.querySelector('.Ui-TheLayout-Navigation-Backdrop');
            if (element) {
                if (getComputedStyle(element).opacity === '1') {
                    this.closeNavigation();
                }
            }
        };
        this.providerValue = {
            leftSidebarPlaceholderRef: react_1.default.createRef(),
            rightSidebarPlaceholderRef: react_1.default.createRef(),
            attachSidebar: (sd) => {
                this.setState(prevState => (Object.assign(Object.assign({}, prevState), { attachedSidebars: [...prevState.attachedSidebars, sd] })));
            },
            detachSidebar: (sd) => {
                this.setState(prevState => (Object.assign(Object.assign({}, prevState), { attachedSidebars: prevState.attachedSidebars.filter(d => d.id !== sd.id) })));
            },
            updateSidebar: (sd) => {
                this.setState(prevState => (Object.assign(Object.assign({}, prevState), { attachedSidebars: prevState.attachedSidebars.map(d => {
                        if (sd.id === d.id) {
                            return Object.assign(Object.assign({}, d), sd);
                        }
                        return d;
                    }) })));
            },
            setBreadcrumbs: (breadcrumbs) => {
                this.setState({
                    breadcrumbs,
                });
            },
            setTitle: (title) => {
                this.setState({
                    title,
                });
            },
            closeNavigation: this.closeNavigation,
            closeNavigationMobile: this.closeNavigationMobile,
            unsetBreadcrumbs: () => {
                this.setState({
                    breadcrumbs: null,
                });
            },
            unsetTitle: () => {
                this.setState({
                    title: this.props.title,
                });
            },
            setBackAction: backAction => {
                this.setState({
                    backAction,
                });
            },
            unsetBackAction: () => {
                this.setState({
                    backAction: null,
                });
            },
        };
        this.onMenuToggle = () => {
            this.setState(prevState => ({
                navigationOpened: !prevState.navigationOpened,
            }));
        };
        this.getWindowTitle = () => {
            var _a;
            const { app, appSpace } = this.props;
            return [
                app ? app.name : '',
                appSpace ? ((_a = appSpace.org_profile) === null || _a === void 0 ? void 0 : _a.name) || '' : '',
            ]
                .filter(Boolean)
                .join(' | ');
        };
        const navigationState = js_cookie_1.default.get(NAVIGATION_OPENED_COOKIES_KEY);
        this.state = {
            attachedSidebars: [],
            navigationOpened: !navigationState || navigationState === '1',
            breadcrumbs: null,
            title: props.title,
            backAction: null,
            isRolesManagerOpened: false,
        };
    }
    componentDidMount() {
        this.providerValue = Object.assign({}, this.providerValue);
        this.forceUpdate();
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.navigationOpened !== this.state.navigationOpened) {
            js_cookie_1.default.set(NAVIGATION_OPENED_COOKIES_KEY, this.state.navigationOpened ? '1' : '0');
        }
        if ((0, utilities_1.isBrowser)()) {
            window.document.title = this.getWindowTitle();
        }
    }
    render() {
        const { children, className, top, bottom, userName, userPictureSrc, notificationCount, navigation, onLogout, onClose, customNavigation, experimentalStatusBarActions, renderNavigationLink, app, appSpace, appSpaces, apps, theme, userSubName, useContext, accessToken, loggingOut, } = this.props;
        const { attachedSidebars, navigationOpened, title, backAction } = this.state;
        const isPushingFromLeft = attachedSidebars
            .filter(sd => !sd.modal && sd.position === 'left')
            .some(sd => !!sd.opened);
        const isPushingFromRight = attachedSidebars
            .filter(sd => !sd.modal && sd.position === 'right')
            .some(sd => !!sd.opened);
        return (react_1.default.createElement(LayoutContext_1.Provider, { value: this.providerValue },
            this.state.isRolesManagerOpened && (react_1.default.createElement(roles_connector_1.default, { opened: this.state.isRolesManagerOpened, appSpace: appSpace ? appSpace.app_space : '', appId: appSpace ? appSpace.app_id : '', accessToken: accessToken || '', onClose: () => {
                    this.setState({ isRolesManagerOpened: false });
                }, onError: (e) => {
                    alert(e.message);
                    this.setState({ isRolesManagerOpened: false });
                    throw e;
                }, onUnauthorized: () => {
                    this.setState({ isRolesManagerOpened: false });
                    throw Error('Neautorizovaný pre správu používateľov');
                } })),
            react_1.default.createElement(Wrapper, { className: className },
                react_1.default.createElement(StatusBar_1.default, null,
                    !!(navigation || customNavigation) && (react_1.default.createElement(StatusBar_1.default.Button, { onClick: this.onMenuToggle },
                        react_1.default.createElement(Icon_1.default, { name: "burger", size: "l", color: theme.color.primary }))),
                    app && (react_1.default.createElement(StatusBarAppSwitch_1.default, { app: app, apps: apps, appSpace: appSpace })),
                    appSpace && (react_1.default.createElement(StatusBarAppSpaceSwitch_1.default, { appSpace: appSpace, appSpaces: appSpaces, app: app })),
                    (appSpace === null || appSpace === void 0 ? void 0 : appSpace.grant) && accessToken && (react_1.default.createElement(StatusBar_1.default.Button, { onClick: () => {
                            this.setState({ isRolesManagerOpened: true });
                        } },
                        react_1.default.createElement(Icon_1.default, { name: "group", size: "l", color: theme.color.primary }))),
                    react_1.default.createElement(StatusBar_1.default.Spacer, null),
                    experimentalStatusBarActions &&
                        experimentalStatusBarActions.length > 0 &&
                        experimentalStatusBarActions.map((action, idx) => (react_1.default.createElement(StatusBarAction_1.default, { key: idx, onClick: action.onClick, icon: action.icon, label: action.label }))),
                    notificationCount !== void 0 && (react_1.default.createElement(StatusBarNotifications_1.default, { notificationCount: notificationCount })),
                    userName && (react_1.default.createElement(StatusBarUser_1.default, { userName: userName, userSubName: userSubName, userPictureSrc: userPictureSrc, onLogout: onLogout, loggingOut: loggingOut })),
                    onClose && react_1.default.createElement(StatusBarCloseButton_1.default, { onClose: onClose })),
                react_1.default.createElement(InnerWrapper, null,
                    (navigation || customNavigation) && (react_1.default.createElement(Navigation_1.default, { items: navigation ? navigation : [], visible: navigationOpened, onClose: this.closeNavigation, renderLink: renderNavigationLink }, customNavigation)),
                    react_1.default.createElement(Body, null,
                        react_1.default.createElement("div", { ref: this.providerValue.leftSidebarPlaceholderRef }),
                        react_1.default.createElement(Pushable, { "$isPushingFromLeft": !!isPushingFromLeft, "$isPushingFromRight": !!isPushingFromRight },
                            react_1.default.createElement(ScrollLayout_1.default, { topFixed: react_1.default.createElement(react_1.default.Fragment, null,
                                    useContext && (!!title || !!backAction) && (react_1.default.createElement(HeaderBar_1.default, null,
                                        backAction,
                                        title && (react_1.default.createElement(HeaderBar_1.default.Header, null, title)))),
                                    top), bottomFixed: bottom },
                                react_1.default.createElement(ModalContextProvider_1.default, null, children))),
                        react_1.default.createElement("div", { ref: this.providerValue.rightSidebarPlaceholderRef }))))));
    }
}
TheLayout.defaultProps = {
    crumbs: [],
    title: '',
    switchOrgAvailable: true,
    useContext: false,
};
exports.default = (0, styled_components_1.withTheme)(TheLayout);
